// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"cab26b5a6544f2816cfe","258":"2b35d93d4c8f0bc96cdd"}[chunkId] + ".js";
};